import { QueryClient } from 'react-query';

// Exported so that it can be used outside of the react-query context
export const queryClient = new QueryClient();
